// 🔢 Note sur 20
import {RawScore} from "../types";

export const getNormalizedScore = (score: RawScore): number => {
    return score.out_of !== 0 ? parseFloat(((score.score_obtained / score.out_of) * 20).toFixed(2)) : 0;
};

// 📈 Moyenne pondérée cumulée
export const getCumulativeWeightedAverage = (scores: RawScore[]): number[] => {
    const values: number[] = [];
    const coeffs: number[] = [];
    const averages: number[] = [];

    for (const score of scores) {
        const ratio = score.out_of !== 0 ? (score.score_obtained / score.out_of) * score.coefficient : 0;
        values.push(ratio);
        coeffs.push(score.coefficient);

        const totalCoeff = coeffs.reduce((sum, c) => sum + c, 0);
        const weightedSum = values.reduce((sum, v) => sum + v, 0);

        averages.push(totalCoeff !== 0 ? parseFloat(((weightedSum / totalCoeff) * 20).toFixed(2)) : 0); // sur 20
    }

    return averages;
};

// 📊 Médiane pondérée cumulée
export const getCumulativeWeightedMedian = (scores: RawScore[]): number[] => {
    const medians: number[] = [];

    for (let i = 0; i < scores.length; i++) {
        const partialScores = scores.slice(0, i + 1);

        const weightedValues: number[] = [];
        for (const score of partialScores) {
            const normalized = getNormalizedScore(score)
            const count = Math.round(score.coefficient * 100); // pondération
            weightedValues.push(...Array(count).fill(normalized));
        }

        weightedValues.sort((a, b) => a - b);
        const mid = Math.floor(weightedValues.length / 2);
        const median =
            weightedValues.length % 2 === 0
                ? (weightedValues[mid - 1] + weightedValues[mid]) / 2
                : weightedValues[mid];

        medians.push(parseFloat((median).toFixed(2)));
    }
    return medians;
};
